import { Link } from "react-router-dom";
import { AlertTriangle, CalendarDays } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";

export default function MyWeek() {
  const { data, loading } = useFetch("/my-week");
  if (loading || !data) return null;
  return (
    <section className="mb-10 rounded-2xl border bg-card p-6" data-testid="my-week">
      <div className="flex items-baseline justify-between"><p className="eyebrow">My week</p><p className="text-sm text-muted-foreground" data-testid="my-week-count">{data.length === 0 ? "Nothing assigned to you this week" : `${data.length} item${data.length === 1 ? "" : "s"}`}</p></div>
      {data.length > 0 && (
        <ul className="mt-4 divide-y">{data.map((s) => (
          <li key={s.id} data-testid={`my-week-${s.id}`}><Link to={`/projects/${s.project_id}?tab=schedule`} className="flex items-start gap-3 py-2.5 text-sm hover:bg-secondary/40">
            {s.overdue ? <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" /> : <CalendarDays className="mt-0.5 h-4 w-4 shrink-0 text-primary" />}
            <span className="min-w-0 flex-1"><span className="font-medium">{s.title}</span>{s.trade && <span className="ml-2 rounded-full bg-secondary px-2 py-0.5 text-[10px] uppercase tracking-wider">{s.trade}</span>}<span className="block text-xs text-muted-foreground">{s.project_name} · {s.overdue ? "overdue · " : ""}{s.start_date || "TBD"}{s.end_date ? ` → ${s.end_date}` : ""}</span></span>
          </Link></li>))}</ul>
      )}
    </section>
  );
}
